<template>
  <div class="blackbtn selectBtn" v-if="selectCondition" trigger="custom" ref="dropRef"  :class="{'focused':isFocused}" @click="clickBtn">
    <!-- <input type="text" v-model="curItem" disabled @click.stop="clickBtn"> -->
    <span>{{curItem}}</span>
    <em class="iconfont icon-arrow-down"></em>
    <transition name="fade">
      <div class="select-pop" v-if="isFocused && selectCondition.dropList">
      <div class="scroll-box srollbox">
         <ul class="select-list"  v-if="selectCondition.dropList && selectCondition.dropList.length>0">
           <template v-for="item in selectCondition.dropList">
             <li @click.stop="clickItem(item.name?item.name:item)">{{item.name?item.name:item}}</li>
           </template>
        </ul>
        <ul class="select-list"  v-else-if="droplistS && droplistS.length>0">
           <template v-for="item in droplistS">
             <li @click.stop="clickItem(item.name?item.name:item)">{{item.name?item.name:item}}</li>
           </template>
        </ul>
      </div>
    </div>
    </transition>
    
  </div>
</template>

<script>
export default {
  name: 'selectPopBtn',
  props: ['selectCondition',"droplistS"],
  data(){
    return{
      isFocused:false,
      curItem:"",
    }
  },
  watch:{
    selectCondition:{
      handler(newVal,oldVal){
        this.curItem = newVal.defaultName;
      },
      immediate:true
    },
  },
  mounted() {
    document.addEventListener('click',this.outClick)
  },
  destroyed(){
    document.removeEventListener('click',this.outClick)
  },
  methods: {
    clickBtn(){
      this.isFocused = true;
    },
    clickItem(item){
      this.isFocused = false;
      this.curItem = item;
      this.$emit("clickItem",{
        type:this.selectCondition.type,
        typeName:this.selectCondition.defaultName,
        subItem:item
      })
    },
    // 点击外部收起下拉选框
    outClick(e){
      // console.log(this.$refs.dropRef)
      // let dropRef= this.$refs.dropRef.$el
      let dropRef= this.$refs.dropRef
      if(!dropRef.contains(e.target)&&this.isFocused){
         this.isFocused = false
      }
    },

  },
}
</script>
<style scoped >
.fade-enter-active{
  transition: opacity .3s;
}
.fade-leave-active {
  transition: opacity 0.3s;
}
/* .fade-leave-active below version 2.1.8 */
.fade-enter,
.fade-leave-to
  {
  opacity: 0;
}



</style>